module.exports = __webpack_public_path__ + "static/horus_01-b5756355137c198e6b4a392c4a86985b.jpg";